import { TSelectOption } from '@treedis/tour-loader';
import { useCallback, useMemo } from 'react';
import TreedisPublicDAO from '@/api/TreedisPublicDAO';

type TDuplicate = {
  language: string;
  languageEn?: string;
  slug: string;
};

const useLanguage = ({
  initialDuplicates,
  tourSlug,
}: {
  initialDuplicates?: TDuplicate[];
  tourSlug: string;
}) => {
  const languageOptions = useMemo(
    () =>
      initialDuplicates
        ?.map((duplicate) => ({
          label: duplicate?.language || duplicate?.languageEn,
          value: duplicate.slug,
        }))
        .filter((o) => !!o.label),
    [initialDuplicates],
  );

  const defaultLanguage = useMemo(
    () => languageOptions?.find((o) => o.value === tourSlug),
    [languageOptions, tourSlug],
  );

  const handleChange = useCallback(async (lang: TSelectOption) => {
    const tourRes = await TreedisPublicDAO.getTourBySlug({ slug: lang.value });
    const slug = tourRes?.tour?.slug;
    const gameId = tourRes?.tour?.gameId;
    const pathnames = window.location.pathname.split('/');
    pathnames.shift();

    let newPathname;
    switch (pathnames[0]) {
      case 'tour':
        newPathname = `tour/${slug}`;
        break;
      case 'experience':
        if (gameId) {
          newPathname = `experience/${gameId}/${slug}`;
        } else {
          console.error(`No experience configuration for tour ${slug}`);
        }
        break;
      case 'e-commerce-tour':
        newPathname = `e-commerce-tour/${slug}`;
        break;
      default:
        break;
    }

    if (newPathname) {
      window.location.replace(`${window.location.origin}/${newPathname}`);
    }
  }, []);

  return {
    languageOptions,
    defaultLanguage,
    handleChange,
  };
};

export default useLanguage;
